import { createFileRoute } from '@tanstack/react-router';

import { AdminOverviewPage } from '@/components/admin/overview-page';
import { adminHead } from '@/lib/seo';
import {
    adminListCategoriesFn,
    adminOverviewFn,
} from '@/server/functions/admin';

export const Route = createFileRoute('/_admin/admin/')({
    component: OverviewRoute,
    head: () => adminHead('לוח בקרה', '/admin'),
    staleTime: 0,
    preloadStaleTime: 0,
    loader: async () => {
        const [stats, categories] = await Promise.all([
            adminOverviewFn(),
            adminListCategoriesFn(),
        ]);
        return { stats, categories: categories.rows };
    },
});

function OverviewRoute() {
    const { stats, categories } = Route.useLoaderData();
    return <AdminOverviewPage stats={stats} categories={categories} />;
}
